import { MessageCircle, AlertCircle, Lightbulb } from "lucide-react";

export const ALL = "__ALL__";

export const TRANSFORM_LABELS = {
  raw: "Alleen transcript",
  summary: "Samenvatting",
  bullets: "Bulletpoints",
  sop: "Werkinstructie (SOP)",
  article: "Kennisartikel",
};

export const FEEDBACK_TYPE_META = {
  Feedback: { color: "#FFD700", Icon: MessageCircle },
  Bug: { color: "#FF3B30", Icon: AlertCircle },
  Suggestie: { color: "#7CDBFF", Icon: Lightbulb },
};

// -------- F3: Logboek (audit — events only, never content) --------
export const LOGIN_RESULT = {
  login_success: { label: "Gelukt", bg: "#32D74B", fg: "#00150A" },
  login_failed: { label: "Mislukt", bg: "#FFD700", fg: "#000000" },
  login_blocked: { label: "Geblokkeerd", bg: "#FF3B30", fg: "#FFFFFF" },
};

export const ADMIN_ACTION_LABELS = {
  category_created: "aangemaakt",
  category_renamed: "hernoemd",
  category_deactivated: "gedeactiveerd",
  category_deleted: "verwijderd",
  admin_password_force_reset: "wachtwoord-herstel (admin)",
  apikey_question_created: "vraag toegevoegd via koppeling",
  apikey_question_updated: "vraag bijgewerkt via koppeling",
  full_export: "volledige export",
  season_created: "seizoen aangemaakt",
  season_updated: "seizoen bijgewerkt",
  season_deleted: "seizoen verwijderd",
  challenge_created: "uitdaging verstuurd",
  correction_created: "correctiepaar toegevoegd",
  correction_updated: "correctiepaar bijgewerkt",
  corrections_applied: "correcties toegepast op bestaande memo's",
  location_created: "locatie toegevoegd",
  location_renamed: "locatie hernoemd",
  location_activated: "locatie aangezet",
  location_deactivated: "locatie uitgezet",
  location_deleted: "locatie verwijderd",
  user_location_changed: "locatie van teamlid gewijzigd",
  memo_locations_backfilled: "locatie ingevuld op bestaande memo's",
  memo_scope_changed: "geldt overal / alleen hier gewijzigd",
  memo_scope_migrated: "geldt overal / alleen hier ingevuld op bestaande memo's",
  question_varies_by_site_changed: "vraag: verschilt per locatie gewijzigd",
  location_coverage_changed: "locatie: telt mee voor dekking gewijzigd",
  location_coverage_seeded: "hoofdkantoor/Truckssupply tellen niet mee voor dekking",
  memo_site_changed: "locatie van memo gewijzigd",
  user_locations_migrated: "locaties van teamleden omgezet naar een lijst",
  category_descriptions_updated: "uitleg bij categorieën aangescherpt",
  keyword_created: "trefwoord toegevoegd",
  keyword_retried: "trefwoord opnieuw geprobeerd",
  keyword_deleted: "trefwoord verwijderd",
  user_reminder_changed: "wekelijkse herinnering aan/uit gezet",
  site_reminders_sent: "herinneringen aan bedrijfsleiders verstuurd",
  inactive_nudges_sent: "herinnering stille collega's verzonden",
};
